import { SUGGESTION_STATUS } from '@Components/MatchComponents/v2/suggestion-status'
import React, { useContext, useEffect, useState } from 'react'
import './index.scss'
import { MatchSummary } from '@Entities/matching/MatchSummary'
import { getMatchSummary } from '@App/api/routes/rightsholder/matching'
import { StoresContext } from '@App/contexts'
import PointPreloader from '@Components/Preloaders/PointPreloader'
import DashboardNoDataInfo from '@Scenes/RightsholderScene/RightsholderDashboard/DashboardNoDataInfo'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import { Link } from 'react-router'
import Navigation from '@App/navigation'
import LinkedStatusComponent from '@Scenes/RightsholderScene/RightsholderDashboard/DashboardMatchHistoryCard/LinkedStatusComponent'

const isMatchSummaryEmpty = (summary: MatchSummary | undefined) =>
    summary && (summary.submitted || summary.accepted || summary.rejected)

const DashboardMatchHistoryCard = () => {
    const { rightsholderStore } = useContext(StoresContext)
    const [matchSummary, setMatchSummary] = useState<MatchSummary>()
    const [isLoading, setIsLoading] = useState(true)
    const currentRhId = rightsholderStore.currentRightsholderId

    useEffect(() => {
        getMatchSummary(rightsholderStore.currentRightsholderId).then((result) => {
            setMatchSummary(result.data)
            setIsLoading(false)
        })
    }, [])

    return (
        <div className="dashboard-content-card match-history">
            <div className="match-history-title">
                Your Match History
                <CustomToolTip
                    info="Match History is a record of recent match suggestions that you've made for unmatched recording groups."
                    type="?"
                    inverse
                />
            </div>
            <div className="match-history-indicators">
                {isLoading ? (
                    <PointPreloader />
                ) : isMatchSummaryEmpty(matchSummary) ? (
                    <>
                        <LinkedStatusComponent
                            status={SUGGESTION_STATUS.SUBMITTED}
                            count={matchSummary?.submitted ?? 0}
                            rhId={currentRhId}
                        />
                        <LinkedStatusComponent
                            status={SUGGESTION_STATUS.ACCEPTED}
                            count={matchSummary?.accepted ?? 0}
                            rhId={currentRhId}
                        />
                        <LinkedStatusComponent
                            status={SUGGESTION_STATUS.REJECTED}
                            count={matchSummary?.rejected ?? 0}
                            rhId={currentRhId}
                        />
                        <div className="link-container">
                            <Link to={Navigation.rightholder.matchClaim.matchHistory(currentRhId)}>View More</Link>
                        </div>
                    </>
                ) : (
                    <DashboardNoDataInfo type="Match History" />
                )}
            </div>
        </div>
    )
}

export default DashboardMatchHistoryCard
